var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartDarkW16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9.429 2.414a3.69 3.69 0 0 1 4.023 6.021L8 13.887 2.548 8.435a3.692 3.692 0 1 1 5.22-5.22L8 3.446l.231-.231c.343-.343.75-.615 1.198-.8m1.412.786a2.62 2.62 0 0 0-1.855.769L8 4.955l-.986-.986a2.625 2.625 0 1 0-3.712 3.712L8 12.38l4.698-4.698A2.624 2.624 0 0 0 10.84 3.2",
  clipRule: "evenodd"
})));
export default SvgIconHeartDarkW16;